namespace TabAurous.Sales {
    export interface SalesMasterRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        AutoPosting?: boolean;
        PartyId?: number;
        LedgerName?: string;
        PartyCode?: string;
        GstVat?: string;
        Pan?: string;
        Address1?: string;
        Country?: string;
        State?: string;
        City?: string;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        GSTState?: string;
        ItemDetails?: SalesItemsRow[];
        TaxDetails?: SalesTaxRow[];
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        ProductItemImage?: string;
        RoundOff?: number;
        CCNetAmount?: number;
        CCTaxAmount?: number;
        CCGrossAmount?: number;
        CCRoundOff?: number;
        PostingDate?: string;
        IsPosted?: boolean;
        CustomerType?: string;
        TotalSales?: number;
        TotalSalesAmount?: number;
        ActiveCustomers?: number;
        RecencyPoints?: number;
        FrequencyPoints?: number;
        MonetaryPoints?: number;
        TotalPoints?: number;
        Month?: string;
        MonthlySales?: number;
        Username?: string;
        MF?: number;
    }

    export namespace SalesMasterRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Sales.SalesMaster';
        export const deletePermission = 'Sales:Invoice:Delete';
        export const insertPermission = 'Sales:Invoice:Add';
        export const readPermission = '*';
        export const updatePermission = 'Sales:Invoice:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            AutoPosting = "AutoPosting",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            PartyCode = "PartyCode",
            GstVat = "GstVat",
            Pan = "Pan",
            Address1 = "Address1",
            Country = "Country",
            State = "State",
            City = "City",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            GSTState = "GSTState",
            ItemDetails = "ItemDetails",
            TaxDetails = "TaxDetails",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            ProductItemImage = "ProductItemImage",
            RoundOff = "RoundOff",
            CCNetAmount = "CCNetAmount",
            CCTaxAmount = "CCTaxAmount",
            CCGrossAmount = "CCGrossAmount",
            CCRoundOff = "CCRoundOff",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            CustomerType = "CustomerType",
            TotalSales = "TotalSales",
            TotalSalesAmount = "TotalSalesAmount",
            ActiveCustomers = "ActiveCustomers",
            RecencyPoints = "RecencyPoints",
            FrequencyPoints = "FrequencyPoints",
            MonetaryPoints = "MonetaryPoints",
            TotalPoints = "TotalPoints",
            Month = "Month",
            MonthlySales = "MonthlySales",
            Username = "Username",
            MF = "MF"
        }
    }
}
